import { render, staticRenderFns } from "./TransferStatusDropdown.vue?vue&type=template&id=b9bb8556&scoped=true"
import script from "./TransferStatusDropdown.vue?vue&type=script&lang=js"
export * from "./TransferStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./TransferStatusDropdown.vue?vue&type=style&index=0&id=b9bb8556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bb8556",
  null
  
)

export default component.exports